import { Grid, Form, Button, Dropdown, Icon, Checkbox, Input } from 'semantic-ui-react'
import { useState }     from 'react'
import PageHeader from "../Components/pageHeader";
import { Errors } from '../Constants/errors';
import { userRegisterRequest, userDataRequest, usersDataRequest, updateUserRequest, networksDataRequest, contractTypesDataRequest } from '../api/backend';
import { useParams } from 'react-router-dom';
import { displayErrors, displaySuccess } from '../Components/displayNotifications';
import useRecaptcha                 from '../hooks/use-recaptcha.js'

export default UserRegistration

/**
 * () -> React.ReactElement
 * @return React.ReactElement
 */
function UserRegistration () {

    const [optionsNetworkAffiliation, setOptionsNetworkAffiliation] = useState([]);
    const [optionsContractExpirationTypes, setOptionsContractExpirationTypes] = useState([]);
    const [formData, setFormData] = useState({})
    const [invalid, setInvalid] = useState(false);
    const [loading, setLoading] = useState(false);
    const executeRecaptcha                                                      = useRecaptcha ()

    const changeFormData = (e) => {

        setFormData({
            ...formData, [`${e.target.name}`]: e.target.value
        })

    }

    const handleSubmitUserForm = async (e) => {

        e.preventDefault();
        setLoading(true);

        if (!e.target.checkValidity()) {
            setInvalid(true);
            setLoading(false);
            return null;
        }

        const recaptchaResponse = await executeRecaptcha ('registerUser')

        const formData$ = { ... formData, recaptchaResponse }

        let request;

        request = await userRegisterRequest (formData$)

        if ([200, 201, 204].includes(request.status)) {
                displaySuccess("User created succesfully, check you e-mail");
            setLoading(false);
        } else {
            const response = await request.json();
            displayErrors(response);
        }

        setLoading(false);

    }

    return (
        <>
            <Form
                onSubmit={handleSubmitUserForm}
                noValidate
            >
                <div className="ui container" style={{ marginTop: '2em' }}>
                    <PageHeader icon="user" title="Sign Up" />
                    <Grid style={{ marginTop: '2em' }}>
                        <Grid.Row columns={2} stretched>
                            <Grid.Column width={10}>
                                <Form.Field
                                    icon="mail"
                                    name="emailAddress"
                                    value={formData.emailAddress || ''}
                                    onChange={e => changeFormData(e)}
                                    control={Input}
                                    iconPosition={'left'}
                                    label={"E-mail address"}
                                    required
                                    error={invalid && !formData?.emailAddress ? {
                                        content: Errors.email,
                                        pointing: 'below',
                                    } : false}
                                />
                            </Grid.Column>

                                <Grid.Column width={6}>
                                    <Form.Field>
                            <Form.Field
                                                icon="lock"
                                                iconPosition='left'
                                                placeholder="enter password"
                                                name="password"
                                                label="Password"
                                                control={Input}
                                                type="password"
                                                value={formData.password || ''}
                                                onChange={e => changeFormData(e)}
                                                required
                                                error={invalid && !formData?.password ? {
                                                    content: Errors.password,
                                                    pointing: 'below',
                                                } : false}
                                            />
                                    </Form.Field>
                                </Grid.Column>

                        </Grid.Row>
                    </Grid>
                </div>
                <section style={{
                    marginTop: '2em',
                    background: '#E6F4FA',
                    padding: '20px 0px'
                }}>
                    <div
                        className="ui container"
                    >
                        <div style={{ marginTop: '2em' }}>

                            <Grid>
                                <Grid.Row columns={3} stretched>
                                    <Grid.Column width={10}>
                                        <Form.Field
                                            label="Company name"
                                            icon="building"
                                            iconPosition='left'
                                            name="companyName"
                                            value={formData.companyName || ''}
                                            onChange={e => changeFormData(e)}
                                            control={Input}
                                            error={invalid && !formData?.companyName ? {
                                                content: Errors.required,
                                                pointing: 'below',
                                            } : false}
                                            required
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={6}>
                                        <Form.Field
                                            label="Company phone"
                                            icon="phone"
                                            iconPosition='left'
                                            name="companyPhoneNumber"
                                            value={formData.companyPhoneNumber || ''}
                                            onChange={e => changeFormData(e)}
                                            control={Input}
                                            required
                                            error={invalid && !formData?.companyPhoneNumber ? {
                                                content: Errors.required,
                                                pointing: 'below',
                                            } : false}
                                        />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row columns={2} stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            label="Company address"
                                            icon="home"
                                            iconPosition='left'
                                            name="companyAddress"
                                            value={formData.companyAddress || ''}
                                            onChange={e => changeFormData(e)}
                                            control={Input}
                                            required
                                            error={invalid && !formData?.companyAddress ? {
                                                content: Errors.required,
                                                pointing: 'below',
                                            } : false}
                                        />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row columns={3} stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            label="Company postal code"
                                            icon="map marker alternate"
                                            iconPosition='left'
                                            name="companyPostalCode"
                                            value={formData.companyPostalCode || ''}
                                            onChange={e => changeFormData(e)}
                                            control={Input}
                                            required
                                            error={invalid && !formData?.companyPostalCode ? {
                                                content: Errors.required,
                                                pointing: 'below',
                                            } : false}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field
                                            label="Company city"
                                            icon="globe"
                                            iconPosition='left'
                                            name="companyCity"
                                            value={formData.companyCity || ''}
                                            onChange={e => changeFormData(e)}
                                            control={Input}
                                            required
                                            error={invalid && !formData?.companyCity ? {
                                                content: Errors.required,
                                                pointing: 'below',
                                            } : false}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field
                                            label="Company Country"
                                            icon="globe"
                                            iconPosition='left'
                                            name="companyCountry"
                                            value={formData.companyCountry || ''}
                                            onChange={e => changeFormData(e)}
                                            control={Input}
                                            required
                                            error={invalid && !formData?.companyCountry ? {
                                                content: Errors.required,
                                                pointing: 'below',
                                            } : false}
                                        />
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>


                        </div >
                    </div >
                </section>

                <div
                    className="ui container"
                >
                    <Grid style={{ marginTop: '2em' }}>

                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <Form.Field
                                    label="Contact person name"
                                    icon="user"
                                    iconPosition='left'
                                    name="contact"
                                    value={formData.contact || ''}
                                    onChange={e => changeFormData(e)}
                                    control={Input}
                                    required
                                    error={invalid && !formData?.contact ? {
                                        content: Errors.required,
                                        pointing: 'below',
                                    } : false}
                                />

                            </Grid.Column>
                            <Grid.Column>
                                <Form.Field
                                    label="Mobile phone number"
                                    icon="mobile alternate"
                                    iconPosition='left'
                                    name="mobilePhoneNumber"
                                    value={formData.mobilePhoneNumber || ''}
                                    onChange={e => changeFormData(e)}
                                    control={Input}
                                    required
                                    error={invalid && !formData?.mobilePhoneNumber ? {
                                        content: Errors.required,
                                        pointing: 'below',
                                    } : false}
                                >
                                </Form.Field>
                            </Grid.Column>
                            <Grid.Column>
                                <Form.Field
                                    control={Input}
                                    label="Assured/Network member"
                                    name="assuredNetworkMember"
                                    onChange={changeFormData}
                                    required
                                    value={formData.assuredNetworkMember ?? ''}
                                    error={invalid
                                        && !formData.assuredNetworkMember
                                        && {
                                            content:    Errors.required,
                                            pointing:   'below'
                                        }
                                    }
                                >
                                </Form.Field>
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row columns={3}>
                            <Grid.Column>
                                <Button
                                    color="blue"
                                    icon
                                    labelPosition='left'
                                    disabled={loading || executeRecaptcha === null}
                                    name="Sign up"
                                >
                                    <Icon name='save' />
                                    Sign up
                                </Button>
                            </Grid.Column>
                        </Grid.Row>

                    </Grid>
                </div>
            </Form >
        </>
    )
}
